/** Exact Backend seedConfirmSchema value — do not change. */
export const SEED_MEDITATION_ACHIEVEMENTS_CONFIRM = 'SEED_MEDITATION_ACHIEVEMENTS';

/** Canonical deferred badge numbers (seed / product). */
export const DEFERRED_BADGE_NUMBERS = [20, 29, 30, 31, 32];
